var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col mb-3" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "row no-gutters" }, [
        _c("div", { staticClass: "col-sm-2 public-course-card" }),
        _c("div", { staticClass: "col-sm-10" }, [
          _c(
            "div",
            {
              staticClass:
                "card-body d-flex flex-column h-100 justify-content-between"
            },
            [
              _c("div", [
                _c("h5", { staticClass: "card-title mb-0" }, [
                  _c(
                    "a",
                    { attrs: { href: "/course/" + _vm.course.alias + "/" } },
                    [_vm._v(_vm._s(_vm.course.name))]
                  )
                ]),
                _c("p", { staticClass: "card-text" }, [
                  _c("small", [_vm._v(_vm._s(_vm.course.school_name))])
                ])
              ]),
              _c("div", { staticClass: "card-text course-data" }, [
                _c("p", { staticClass: "mb-2" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.getFormattedLessonAndStudentCount(_vm.course)
                      ) +
                      " "
                  )
                ]),
                _c("p", { staticClass: "mb-2" }, [
                  _vm._v(_vm._s(_vm.courseLevelText(_vm.course)))
                ]),
                _vm.loggedIn
                  ? _c("div", { staticClass: "text-center mt-1" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary text-white",
                          attrs: {
                            role: "button",
                            href: "/course/" + _vm.course.alias + "/"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.course.alreadyStarted
                                  ? _vm.T.courseCardCourseResume
                                  : _vm.T.wordsStart
                              ) +
                              " "
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }